import { defineMessages } from 'react-intl';

export const scope = 'app.containers.QuickOrder';

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Đặt hàng nhanh',
  },
  analyzeButton: {
    id: `${scope}.analyzeButton`,
    defaultMessage: 'Phân tích AI',
  },
  new: {
    id: `${scope}.new`,
    defaultMessage: 'Mới',
  },
  leaveConfirmTitle: {
    id: `${scope}.leaveConfirmTitle`,
    defaultMessage: 'Rời khỏi trang?',
  },
  leaveReanalyzeTitle: {
    id: `${scope}.leaveReanalyzeTitle`,
    defaultMessage: 'Phân tích lại?',
  },
  leaveConfirmBody: {
    id: `${scope}.leaveConfirmBody`,
    defaultMessage:
      'Bạn có {count} sản phẩm chưa thêm vào giỏ hàng. Nếu rời trang, danh sách đặt hàng nhanh hiện tại sẽ bị mất và không thể khôi phục.',
  },
  leaveReanalyzeBody: {
    id: `${scope}.leaveReanalyzeBody`,
    defaultMessage:
      'Bạn có {count} sản phẩm chưa thêm vào giỏ hàng. Nếu phân tích lại, danh sách đặt hàng nhanh hiện tại sẽ bị mất và không thể khôi phục.',
  },
  leaveConfirmCancel: {
    id: `${scope}.leaveConfirmCancel`,
    defaultMessage: 'Ở lại',
  },
  leaveConfirmOk: {
    id: `${scope}.leaveConfirmOk`,
    defaultMessage: 'Rời trang',
  },
  leaveConfirmReanalyze: {
    id: `${scope}.leaveConfirmReanalyze`,
    defaultMessage: 'Phân tích lại',
  },
});
